import type { Environment } from '@/core/lib/env/env.context';
import { ACTUAL_ENV, valuesFromProcess } from '@/core/lib/env/env.context';
import { ApiVersions } from '@/core/lib/fetch';
import api from '@/core/lib/fetch/api';
import { ContactsDonationsResult, contactsDonationsResultSchema, ContactType } from '@/core/types/contact';

const getUrl = () => valuesFromProcess[ACTUAL_ENV as Environment]?.DONNONS_API_URL;

const query = {
  get: async ({ from }: { from: number }, token: string) =>
    api.get<ContactsDonationsResult>({
      url: `${getUrl()}${ApiVersions.V1}/user/contacts/donations?type=${ContactType.FOLLOW}&from=${from}`,
      schema: contactsDonationsResultSchema,
      token,
    }),
};

export default { query };
